import type { FaireProductEntity } from "../../entity_types/product";

export const p_7b984t9mrm: FaireProductEntity = {
  token: "p_7b984t9mrm",
  type: "product",
  name: "Ready To DREAM Traceable Sleep Aid w/ Time Release Melatonin",
  brandToken: "b_3zqche274q",
  brandName: "Ready To",
  imageUrl:
    "https://cdn.faire.com/fastly/28b5676603b9c61610525846c56dba62cd2744a18f7f1bda92ab291d05f30578.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c6f8cebc379cf34ee13af6eceb656b5b4615500e2ea4104c72420f6bba175bea.jpeg",
    "https://cdn.faire.com/fastly/f51fe1087eb9f95950f1dd85362918be7c942ec73c007a1239842b69a91d6ded.png",
    "https://cdn.faire.com/fastly/7ac00aec0e3e754ce0f9d10b794754f04f50f09cf43427e00fb319315e8fd8b4.jpeg",
    "https://cdn.faire.com/fastly/a3132e85560822152409e34b737a98d20d479d55030de37dadc26bbe782e05a9.jpeg",
    "https://cdn.faire.com/fastly/c8976d340181be03138c29729cfff9658446d31c839f42f6ec476dd80db29cdd.jpeg",
    "https://cdn.faire.com/fastly/f60afa7d05602bc9d83121a8bf96bf4e37e87721ec7e91ff8ba64033d1b8027c.jpeg",
    "https://cdn.faire.com/fastly/a5d51dd4015c28e010c8d07f0bf54c1cd903bd7ededb792cbea680c1bbd71051.jpeg",
    "https://cdn.faire.com/fastly/925868a6626de460cdd90c757747d8ce2d365ff7b2b52eaf30d021301bdc0b07.jpeg",
  ],
  priceDollars: 17.95,
  description:
    "PhD-developed sleep and calm formula with clinically studied Sensoril® Ashwagandha, MicroActive® Melatonin, Albion® Magnesium, Vitamin B6 and Botanicals.*\n\nTraceable Ingredients: You’ll see where each comes from, how they are sourced, and why they’re combined. Every detail is meticulously on the blockchain. Trust verifiable data, not just our words.\n\nSleep Through the Night: A revolutionary blend of 7-hour sustained-release MicroActive® Melatonin helps you fall asleep and stay asleep. Clinically tested Sensoril® ashwagandha reduces sleeplessness from stress. Chelated magnesium guides the mind and body into relaxation. A blend of botanicals, including Hops, Valerian, and Chamomile to soothe and encourage rest.*\n\nHonestly Honest: We refuse to use unnecessary additives, preservatives, and common allergens. We are animal-free and cruelty-free.\n\nSustainable Packaging: Our packaging is 100% plastic-free and compostable.",
  tags: [],
  msrpDollars: 29.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:34.946Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
